import dayjs from 'dayjs';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../../utils/axios';
import { dispatch } from '../../store';

const initialState = {
    isLoading: false,
    error: null,
    deliveries: []
}

const slice = createSlice({
    name: "Customer Deliveries",
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },
        // STOP LOADING
        stopLoading(state) {
            state.isLoading = false;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // getDeliveriesSuccess
        getDeliveriesSuccess(state, action) {
            state.deliveries = action.payload;
        }
    }
});

// Reducer 
export default slice.reducer;

// Actions
export const {
    startLoading, hasError, getDeliveriesSuccess
} = slice.actions;

export function getCustomerDeliveries({
    customerId,
    filterPickupDateFrom: filterPickupDateFrom,
    filterPickupDateEnd: filterPickupDateEnd,
    searchVal: searchVal,
    searchByOrderId: searchByOrderId
}) {
    return async () => {
        try {
            let pathName = `/retailer_app/api/v1/retailers/customer_orders/${customerId}`;

            const fromDate = dayjs(filterPickupDateFrom).format('YYYY-MM-DD');
            const endDate = dayjs(filterPickupDateEnd).format('YYYY-MM-DD');
            pathName = `${pathName}?start_date=${fromDate}&end_date=${endDate}&by_order=${searchByOrderId}`;

            if (searchVal.trim().length > 0) {
                pathName = `${pathName}&shipper_name=${searchVal}`
            }
            dispatch(slice.actions.startLoading());
            const response = await axios.get(pathName);
            const { data } = response;
            const receivedData = data?.data || [];
            if (!receivedData) return []
            const deserializedData = deserialize(receivedData);
            dispatch(slice.actions.getDeliveriesSuccess(deserializedData));
            dispatch(slice.actions.stopLoading());
        } catch (error) {
            console.error('Error fetching retailer customers:', error);
            throw error;
        }
    }
}

export function deserialize(data) {
    const dataList = []
    data.forEach((order) => {
        const singleOrder = {
            id: order?.id,
            shipper: order?.attributes?.shipper,
            invoiceNo: order?.attributes?.invoice_no || '',
            LPONo: order?.attributes?.lpo_no || '',
            DNoteNumber: order?.attributes?.dnote?.data?.attributes?.dnote_number || '',
            orderlineItemSummary: order?.attributes?.order_summary,
            orderlineItems: order?.attributes?.orderline_items,
            totalPackages: order?.attributes?.total_packages,
            totalWeight: order?.attributes?.total_weight,
            status: order?.attributes?.status_summary,
            pickupDate: order?.attributes?.pickup_date,
            expectedArrivalDate: order?.attributes?.expected_arrival_date
        }
        dataList.push(singleOrder)
    })

    return dataList
}